(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["member-detail"]) return;
  try {
    
  // Share the profile. Native share sheet where the browser has one (that is where
  // members actually share, on a phone), clipboard otherwise.
  //
  // Delegated from document so the handler survives Shopify's section re-render in
  // the theme editor without being bound twice.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.member-detail__share-btn');
    if (!btn) return;

    var wrap = btn.parentElement;
    var status = wrap ? wrap.querySelector('.member-detail__share-status') : null;
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    var text = btn.getAttribute('data-share-text') || '';

    function say(message) {
      if (!status) return;
      status.textContent = message;
      window.setTimeout(function () { status.textContent = ''; }, 2500);
    }

    if (navigator.share) {
      navigator.share({ title: title, text: text, url: url }).catch(function (err) {
        // A cancelled share sheet rejects with AbortError. That is the member
        // changing her mind, not a failure, so it must stay silent.
        if (err && err.name !== 'AbortError') say('Could not open share.');
      });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () { say('Link copied'); },
        function () { window.prompt('Copy this link:', url); }
      );
      return;
    }

    window.prompt('Copy this link:', url);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["members-area"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LABEL = 'Copy code';
    var COPIED = 'Copied';

    function canCopy() {
      return Boolean(navigator.clipboard && window.isSecureContext);
    }

    // Show copy buttons only where the Clipboard API can actually work.
    function reveal() {
      if (!canCopy()) return;
      document.querySelectorAll('[data-members-copy]').forEach(function (button) {
        button.hidden = false;
      });
    }

    // Fallback when the write is refused: select the code for a manual copy.
    function selectCode(button, status) {
      var code = document.getElementById(button.getAttribute('aria-describedby'));
      if (code) {
        var range = document.createRange();
        range.selectNodeContents(code);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
      if (status) status.textContent = 'Code selected. Press Ctrl+C or Cmd+C to copy it.';
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-members-copy]');
      if (!button) return;
      var value = button.getAttribute('data-members-copy');
      var status = button.parentElement.querySelector('[data-members-copy-status]');

      navigator.clipboard.writeText(value).then(
        function () {
          button.textContent = COPIED;
          if (status) status.textContent = 'Code ' + value + ' copied to clipboard.';
          window.setTimeout(function () {
            button.textContent = LABEL;
            if (status) status.textContent = '';
          }, 2000);
        },
        function () {
          selectCode(button, status);
        }
      );
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }
    // Theme Editor re-renders sections in place.
    document.addEventListener('shopify:section:load', reveal);
  })();

  } catch(e) { console.error(e); }
})();
})();
